import { generatePath } from 'react-router-dom';
import log from 'loglevel';
import request from '../api/index';
import { BackofficeUser } from '../@types/user';
import {
  deleteUserTokens, getUserTokens, setUserTokens, tokenExpirationDate,
} from '../utils';
import { API_ROUTES } from '../consts';
import { LoginAsAdminResponse } from '../@types/Account';

const TAG = '[AUTH_API]';

type Login = {
  email: string,
  password: string,
}

export const login = async ({ email, password }: Login): Promise<void> => {
  const username = email.substring(0, email.lastIndexOf('@'));
  const { data } = await request.post(API_ROUTES.LOGIN, {
    grant_type: 'password',
    username,
    password,
  });
  const {
    token_type: tokenType,
    access_token: accessToken,
    refresh_token: refreshToken,
    expires_in: expires,
  } = data;
  setUserTokens({
    tokenType, accessToken, refreshToken, expired: tokenExpirationDate(expires),
  });
  const maskedPassword = password.replace(/./g, '*');
  log.debug(TAG, `User was logged in with email: ${email} and pass: ${maskedPassword}`);
};

export const logout = async (): Promise<void> => {
  await request.post(API_ROUTES.LOG_OUT);
  deleteUserTokens();
  log.debug(TAG, 'User was logged out');
};

export const getUser = async (): Promise<BackofficeUser | null> => {
  const userTokens = getUserTokens();
  if (!userTokens) {
    log.debug(TAG, 'Missing user token');

    return null;
  }
  const { data: user } = await request.get(API_ROUTES.USER_INFO);
  log.debug(TAG, 'Fetch user information');
  
  return user;
};

export const loginAsAdmin = async (accountId: string): Promise<LoginAsAdminResponse> => {
  const path = generatePath(API_ROUTES.LOGIN_AS_ADMIN, { accountId });

  const { data } = await request.put(path);
  log.debug(TAG, 'User was logged in as Admin');
  
  return data;
};
